<template>
	<el-input
		v-model="inputValue"
		:placeholder="field?.dynamicFieldDescribed || ''"
		maxlength="50"
		@input="handleInput"
	></el-input>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
	field: {
		type: Object,
		required: true
	}
});
const emits = defineEmits(['update']);

const inputValue = ref(props.field?.dynamicFieldValue || '');

const handleInput = val => {
	emits('update', val);
};
</script>

<style lang="less" scoped></style>
